module.exports = __webpack_public_path__ + "media/finish_fail.643db1c2.wav";